<template>
  <w-flex justify-center align-center v-if="($zutil.role('Penternak') || $zutil.role('Pentadbir Sistem'))&& $page.props.auth.user.id == data.user_id">
    <div class="w-card__content content-hardcode">
      <w-flex class="mt3">
        <div class="xs11 text-right" >
          <w-button dark class="green--bg ml1" @click="add()">
             <w-icon class="mr1">fal fa-plus</w-icon> Mohon
         </w-button>
        </div>
      </w-flex>
    </div>
  </w-flex>
  <w-flex justify-center align-center v-else-if="$zutil.role('Pentadbir Sistem') ">
    <div class="w-card__content content-hardcode">
      <w-flex class="mt3">
        <div class="xs11 text-right" >
          <w-button dark class="green--bg ml1" @click="add()">
             <w-icon class="mr1">fal fa-plus</w-icon> Mohon
         </w-button>
        </div>
      </w-flex>
    </div>
  </w-flex>
  <div class="w-table-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
          <th class="w-table__header  text-left" width="1%">No</th>
          <th class="w-table__header  text-left">Tarikh Mohon</th>
          <th class="w-table__header  text-left">Al Man</th>
          <th class="w-table__header  text-left">Tarikh Check In</th>
          <th class="w-table__header  text-left">Tajuk</th>
          <th class="w-table__header  text-left">Status</th>
          <th class="w-table__header  text-left"  width="1%">Tindakan</th>
        </tr>
      </thead>

      <tbody>
        <template v-if="datas.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in datas">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" >{{ind+1}}</td>
            <td class="w-table__cell text-left" >{{dt.tarikh_mohon}}</td>
            <td class="w-table__cell text-left" >{{dt.user}}</td>
            <td class="w-table__cell text-left" >{{dt.tarikh}}</td>
            <td class="w-table__cell text-left" >{{dt.tajuk}}</td>
            <td class="w-table__cell text-left" >{{dt.lkp_status}}</td>
            <td class="w-table__cell text-left" >
              <w-button dark class="info-dark1--bg" @click="papar(dt)" >
                 <w-icon class="mr1">fal fa-eye</w-icon> Papar
             </w-button>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
  <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent"  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      <!-- Pemohonan Check In Premis -->

      Permohonan Perkhidmatan
    </template>
    <w-form  ref="form"  v-model="dialog.valid" @validate="submit" @success="success" >

      <z-select :items="user" label="Al Man *"  v-model="form.user_id"  :validators="[validators.required]"  />
      <z-input label="Tajuk *" type="text" v-model="form.tajuk"  :validators="[validators.required]" />
       <w-textarea label="Keterangan"  v-model="form.keterangan" />
       <div class="w-table-wrap" style="max-height: 400px;">
        <table class="w-table" color="light" >
          <thead>
            <tr>
              <th class="w-table__header  text-left" width="1%">No</th>
              <th class="w-table__header  text-left">Baka</th>
              <th class="w-table__header  text-left">Kod</th>
              <th class="w-table__header  text-left">Nama</th>
              <th class="w-table__header  text-left">Jantan</th>
              <th class="w-table__header  text-left">Status</th>
              <th class="w-table__header  text-left">Pemeriksaan</th>
            </tr>
          </thead>

          <tbody>
            <template v-if="ternakan.length == 0">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
              </tr>
            </template>
            <template v-for="(dt, ind) in ternakan">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" >{{ind+1}}</td>
                <td class="w-table__cell text-left" >{{dt.baka}}</td>
                <td class="w-table__cell text-left" >{{dt.kode}}</td>
                <td class="w-table__cell text-left" >{{dt.nama}}</td>
                <td class="w-table__cell text-left" >{{dt.jantina_nama}}</td>
                <td class="w-table__cell text-left" >{{dt.status}}</td>
                <td class="w-table__cell text-left" >
                  <template v-if="dt.jantina == 1">
                    <w-select :items="pemeriksan_jantan"   v-model="dt.lkp_pemeriksaan_id"  />
                  </template>
                  <template v-else>
                    <w-select :items="pemeriksan_betina"   v-model="dt.lkp_pemeriksaan_id"  />
                  </template>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </w-form>
    <template #actions>
      <div class="spacer" />
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">Tutup</w-button>
      <w-button class="ml1" :loading="dialog.loading" @click="$refs.form.validate()">Hantar Permohonan</w-button>
    </template>
  </w-dialog>

  <w-dialog v-model="dialog_papar.show" :fullscreen="dialog_papar.fullscreen" :width="dialog_papar.width" :persistent="dialog_papar.persistent"  :persistent-no-animation="dialog_papar.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Pemohonan Check In Premis
    </template>
      <div class="w-flex wrap smd-column" >
        <div class="grow ">
          <div class="fw-normal my1 fs-1"><b>No Premis :</b><br>{{data.no_premis}}&nbsp;</div>
          <div class="fw-normal my1 fs-1"><b>Al Man :</b><br>{{data_pemeriksan.user}}&nbsp;</div>
          <div class="fw-normal my1 fs-1"><b>Tarikh Mohon:</b><br>{{data_pemeriksan.tarikh_mohon}}&nbsp;</div>
          <div class="fw-normal my1 fs-1"><b>Tarikh Check In:</b><br>{{data_pemeriksan.tarikh}}&nbsp;</div>
        </div>
        <div class="mx2"></div>
        <div class="grow ">
          <div class="fw-normal my1 fs-1"><b>Tajuk :</b><br>{{data_pemeriksan.tajuk}}&nbsp;</div>
          <div class="fw-normal my1 fs-1"><b>Keterangan :</b><br>{{data.keterangan}}&nbsp;</div>
          <div class="fw-normal my1 fs-1"><b>Status :</b><br>{{data_pemeriksan.lkp_status}}&nbsp;</div>
        </div>
      </div>
      
       <div class="w-table-wrap" style="max-height: 400px;">
        <table class="w-table" color="light" >
          <thead>
            <tr>
              <th class="w-table__header  text-left" width="1%">No</th>
              <th class="w-table__header  text-left">Ternakan</th>
              <th class="w-table__header  text-left">Baka</th>
              <th class="w-table__header  text-left">Jantina</th>
              <th class="w-table__header  text-left">Pemeriksaan</th>
              <th class="w-table__header  text-left">Al Man</th>
              <th class="w-table__header  text-left">Status</th>
              <th class="w-table__header  text-left">Keterangan</th>
            </tr>
          </thead>

          <tbody>
            <template v-if="data_pemeriksan.datas.length == 0">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
              </tr>
            </template>
            <template v-for="(dt, ind) in data_pemeriksan.datas">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" >{{ind+1}}</td>
                <td class="w-table__cell text-left" >{{dt.ternakan}}</td>
                <td class="w-table__cell text-left" >{{dt.baka}}</td>
                <td class="w-table__cell text-left" >{{dt.jantina}}</td>
                <td class="w-table__cell text-left" >{{dt.lkp_pemeriksaan}}</td>
                <td class="w-table__cell text-left" >{{dt.user}}</td>
                <td class="w-table__cell text-left" >{{dt.lkp_status}}</td>
                <td class="w-table__cell text-left" >{{dt.keterangan}}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    
    <template #actions>
      <div class="spacer" />
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog_papar.show = false">Tutup</w-button>
    </template>
  </w-dialog>

</template>

<script>
export default {
  name: "Pemeriksaan",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {
       
      },
      datas : [],
      data_pemeriksan : {
        tajuk : '',
        keterangan : '',
        user : '',
        tarikh_mohon : '',
        tarikh : '',
        datas : []
      },
      ternakan : [],
      user : [],
      pemeriksan_jantan : [],
      pemeriksan_betina : [],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      dialog_papar: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      
      validators: {
        required: value => !!value || 'Wajib Isi.',
        
      }, 

      
    }
  },
  methods:{
    add(){
      this.dialog.show = true
      this.form = {
        tajuk : '',
        keterangan : '',
        user_id : ''
      }
    },
    
    papar(dt){
      this.data_pemeriksan.tajuk = dt.tajuk
      this.data_pemeriksan.keterangan = dt.keterangan
      this.data_pemeriksan.user = dt.user
      this.data_pemeriksan.tarikh = dt.tarikh
      this.data_pemeriksan.tarikh_mohon = dt.tarikh_mohon
      this.data_pemeriksan.lkp_status = dt.lkp_status
      this.dialog_papar.show = true
      this.$zcomm.get(this.api_service + 'premis/pemeriksaan_butiran/'+dt.id, {}).then(res => {
        this.data_pemeriksan.datas = res
      })
    },
    getData(){
      this.$zcomm.get(this.api_service + 'premis/pemeriksaan/'+this.data.id, {}).then(res => {
        this.datas = res
      })
      this.$zcomm.get(this.api_service + 'premis/pemeriksaan_ternakan/'+this.data.id, {}).then(res => {
        this.ternakan = res
      })
    },
    getUser(){
      this.$zcomm.get(this.api_service + 'lookup/alman', {}).then(res => {
        this.user = res
      })
    },
    getLkpPemeriksaan(){
      this.$zcomm.get(this.api_service + 'lookup/pemeriksaan_jantan', {}).then(res => {
        this.pemeriksan_jantan = res
      })
      this.$zcomm.get(this.api_service + 'lookup/pemeriksaan_betina', {}).then(res => {
        this.pemeriksan_betina = res
      })
    },

    submit() {
      var jumlah = 0
      for (var t in this.ternakan) {
        if(this.ternakan[t].lkp_pemeriksaan_id){
          jumlah = jumlah + 1
        }
      }
      if(this.form.tajuk && this.form.user_id > 0 && jumlah > 0){
        
        this.form.premis_id = this.data.id
        this.form.butian = this.ternakan
        this.form.lkp_status_id = 16
        this.$zcomm.add( 'pemeriksaan.store', this.form)
        .then(res => {
          
          this.dialog.show = false;
          this.getData()
        })
        .finally(() => {
            this.dialog.loading = false;

        });
      }
    },

    
    
  },
      
  mounted() {
    this.getData()
    this.getLkpPemeriksaan()
    this.getUser()
    
  }
}
      

</script>  
